import { useTranslation } from "react-i18next";

import ActionButtonLayout from "./ActionButtonLayout";

function InsertApproverButtonLayout ( props ) {

    const { t } = useTranslation();

    return <ActionButtonLayout {...props}>{t("buttonName.insertApprover")}</ActionButtonLayout>;

}

export default InsertApproverButtonLayout;

